import { Injectable } from "@angular/core";
// import { HttpHeaders as Headers } from "@angular/common/http";
//import { Headers } from '@angular/http';
var baseApiUrl = "http://localhost:3526";
var apiUrl = "http://localhost:3526/api";

//Dynamically change BASE and API URL
//For staging

if (window.location.origin !== "http://localhost:4200") {
  var baseApiUrl = window.location.origin; // 'http://52.34.207.5:5115'
  var apiUrl = window.location.origin + "/api"; // 'http://52.34.207.5:5115/api/v3'
}





// if (window.location.origin == "http://localhost:4200") {
//   var baseApiUrl =   'http://54.71.18.74:3540'
//   var apiUrl = "http://54.71.18.74:3540" + "/api"; // 'http://54.71.18.74:3540/api/v3'
// }


//For local  #designer
//  if (window.location.origin == "http://localhost:4200") {
//    var baseApiUrl =   'http://54.201.160.69:3526'
//    var apiUrl = "http://54.201.160.69:3526" + "/api"; // 'http://54.201.160.69:3526/api/v3'
//  }





@Injectable()
export class AppConfig {
  clientUrl = window.location.origin;
  withoutLoginUrls: any = ["login"];
  baseApiUrl: any = baseApiUrl;
  // apiUrl: any = (['localhost', '127.0.0.1'].indexOf(window.location.hostname)!== -1) ? "http://localhost:5115/api/v1" : "http://52.34.207.5:5115/api/v1";
  apiUrl: any = apiUrl;
  assetPath: any = "assets";
  perPageDefault: any = 5;
  statusCode: any = {
    error: 409,
    success: 200,
    success1: 201,
    badRequest: 400,
    unauthorized: 401,
    notFound: 404,
    forbidden: 403,
    invalid: 406,
    serviceUnavailable: 503,
    continue: 100
  };
  role_type: any = {
    admin: "admin",
    employee: "employee",
    agent: "agent"
  };
  pattern: any = {
    NAME: /^[a-zA-Z . \-\']*$/,
    CMPNAME: /^[a-zA-Z0-9 ]*$/,
    AMOUNT: /^[0-9]/,
    userName: /^[a-zA-Z0-9]*$/,
    ROLENAME: /^[a-zA-Z\_\- ]*$/,
    CITY: /^[a-zA-Z . \-\']*$/,
    EMAIL: /^[a-zA-Z0-9]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/,
    POSTAL_CODE: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
    PASSWORD: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{5,15}$/,
    PHONE: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
    DESCRIPT: /^[a-zA-Z\.\' ]*$/,
    PHONE_NO_MASK: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
    CARD_NO_MASK: [
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/
    ],
    CVV_NO_MASK: [/\d/, /\d/, /\d/]
  };
  mob_country_code: any = [
    { key: "+1", text: "+1" },
    { key: "+91", text: "+91" }
  ];
  crmMessages: any = {
    Branch: {
      updateConfirm: "Are you sure you want to update Branch ?",
      removeConfirmation: "Are you sure you want to remove Branch ?",
      onAdd: "Branch added successfully.",
      onRemove: "Branch removed successfully.",
      onUpdate: "Branch updated successfully."
    },
    Client: {
      updateConfirm: "Are you sure you want to update client",
      removeConfirmation: "Are you sure you want to remove client",
      onAdd: "Client added successfully",
      onRemove: "Client removed successfully",
      onUpdate: "Client updated successfully",
      overDueUpdae:"Are you sure you want to Change OVERDUE.?",
      onOverDueUpdae:"OVERDUE Update Successfully."
    },
    Subcontractor: {
      updateConfirm: "Are you sure you want to update subcontractor",
      removeConfirmation: "Are you sure you want to remove subcontractor",
      onAdd: "Subcontractor added successfully",
      onRemove: "Subcontractor removed successfully",
      onUpdate: "Subcontractor updated successfully"
    },
    AddressBook: {
      updateConfirm: "Are you sure you want to update address book",
      removeConfirmation: "Are you sure you want to remove address book",
      onAdd: "Address Book added successfully",
      onRemove: "Address Book  removed successfully",
      onUpdate: "Address Book  updated successfully"
    },
    RateDescription: {
      updateConfirm: "Are you sure you want to update rate description",
      removeConfirmation: "Are you sure you want to remove rate description",
      onAdd: "Rate Description added successfully",
      onRemove: "Rate Description removed successfully",
      onUpdate: "Rate Description updated successfully"
    }
  };

  CRM_dynamic_fields: any = {
    Client: {
      formFields: {
        id: "clientId"
      },
      pageTitle: "Client",
      role: "Client"
    },
    Subcontractor: {
      formFields: {
        id: "subcontractorId"
      },
      pageTitle: "Subcontractor",
      role: "Subcontractor"
    },
    AddressBook: {
      formFields: {
        id: "addressId"
      },
      pageTitle: "Address Book",
      role: "AddressBook"
    }
  };
  //  iconPaths : {
  //    'file-icon' : window.location.origin+
  //  }

  imagePaths: any = {
    'uploadSpinner': '/assets/spinner/fileUpload.gif'
  }


}
